export enum API_URL {
  // https://staging-member-api.shipt.com
  API_GATEWAY = 'api-gateway',
  // next api
  SELF_API = 'self',
}
